<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="
        M1.33301
        1.33325V5.49992H1.81761M14.6148
        7.16659C14.2047
        3.87799
        11.3994
        1.33325
        7.99967
        1.33325C5.20186
        1.33325
        2.80658
        3.05673
        1.81761
        5.49992M1.81761
        5.49992H5.49967M14.6663
        14.6666V10.4999H14.1817M14.1817
        10.4999C13.1928
        12.9431
        10.7975
        14.6666
        7.99967
        14.6666C4.59999
        14.6666
        1.79467
        12.1218
        1.38459
        8.83325M14.1817
        10.4999H10.4997
      "
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "Reload",
  props: {
    stroke: {
      required: false,
      type: String,
      default: '#00A482'
    }
  }
}
</script>
